import { axInstBasic } from "../../components/Service/Service";

export const getArnPayload = (parArn, childArn, filterPayload = {}) => {
  const base = {
    ...(childArn ? { childArn } : { parArn }),
    ...filterPayload,
  };

  Object.keys(base).forEach((key) => {
    if (Array.isArray(base[key]) && base[key].length === 0) {
      delete base[key];
    }
  });

  return base;
};

// Filters API
export const getYearNameList = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}yearListSpareSales`,
      values
    );
    // console.log("API response (yearListSpareSales):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching yearListSpareSales:", error);
    throw error;
  }
};

export const getStateNameList = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}stateListSpareSales`,
      values
    );
    // console.log("API response (stateListSpareSales):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching stateListSpareSales:", error);
    throw error;
  }
};

export const getProductGroupNameList = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}productGroupListSpareSales`,
      values
    );
    // console.log("API response (productGroupListSpareSales):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching productGroupListSpareSales:", error);
    throw error;
  }
};

export const getDealerGroupNameList = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}dealerGroupListSpareSales`,
      values
    );
    // console.log("API response (dealerGroupListSpareSales):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching dealerGroupListSpareSales:", error);
    throw error;
  }
};

// Components API
export const getSparesCount = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}sparesCountFilterUniquePartNoCount`,
      values
    );
    // console.log("API response (sparesCountFilterUniquePartNoCount):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching sparesCountFilterUniquePartNoCount:", error);
    throw error;
  }
};

export const getPartQtyNo = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}partQtyNo`,
      values
    );
    // console.log("API response (partQtyNo):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching partQtyNo:", error);
    throw error;
  }
};

export const getlubsQtyNo = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}lubsQtyNo`,
      values
    );
    // console.log("API response (lubsQtyNo):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching lubsQtyNo:", error);
    throw error;
  }
};

export const totalOtherAmountCount = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}total_other_amount_count`,
      values
    );
    // console.log("API response (total_other_amount_count):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching total_other_amount_count:", error);
    throw error;
  }
};

export const totalPartAmountCount = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}total_part_amount_count`,
      values
    );
    // console.log("API response (total_part_amount_count):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching total_part_amount_count:", error);
    throw error;
  }
};

export const totalLubsAmountCount = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}total_lubs_amount_count`,
      values
    );
    // console.log("API response (total_lubs_amount_count):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching total_lubs_amount_count:", error);
    throw error;
  }
};


export const stateGraphValues = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}stateGraphValues`,
      values
    );
    // console.log("API response (stateGraphValues):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching stateGraphValues:", error);
    throw error;
  }
};

export const monthWiseGraphValues = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}monthWiseGraphValues`,
      values
    );
    // console.log("API response (monthWiseGraphValues):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching monthWiseGraphValues:", error);
    throw error;
  }
};

export const channelPartnerGraphValues = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}channelPartnerGraphValues`,
      values
    );
    // console.log("API response (channelPartnerGraphValues):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching channelPartnerGraphValues:", error);
    throw error;
  }
};

export const dealerStateTableValues = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}dealerStateTableValues`,
      values
    );
    // console.log("API response (dealerStateTableValues):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching dealerStateTableValues:", error);
    throw error;
  }
};

export const monthWiseTableValues = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}monthWiseTableValues`,
      values
    );
    // console.log("API response (monthWiseTableValues):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching monthWiseTableValues:", error);
    throw error;
  }
};

export const channelPartnerWiseTableValues = async (parArn, childArn, filterPayload) => {
  const values = getArnPayload(parArn, childArn, filterPayload);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}channelPartnerWiseTableValues`,
      values
    );
    // console.log("API response (channelPartnerWiseTableValues):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching channelPartnerWiseTableValues:", error);
    throw error;
  }
};





